import {useState} from 'react';
import {AxiosError} from 'axios';

import service, {TMarketingContact} from '../apis/marketingSignup';

export type TUseMarketingEmailService = {
  submitContact({email}: TMarketingContact): void;
  isContactSubmitted: boolean;
  isError: boolean;
};

const useMarketingSignup = (): TUseMarketingEmailService => {
  const [isContactSubmitted, setIsContactSubmitted] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const submitContact = ({email}: TMarketingContact) => {
    setIsContactSubmitted(false);
    service
      .post({email})
      .then(() => {
        setIsContactSubmitted(true);
      })
      .catch((error: AxiosError) => {
        if (window.Sentry) {
          window.Sentry.addBreadcrumb({
            message: 'Signup form request resulted in error',
            category: 'http_request',
            data: {email},
          });
          window.Sentry.captureException(error);
          setIsError(true);
        }
      });
  };

  return {
    submitContact,
    isContactSubmitted,
    isError,
  };
};

export default useMarketingSignup;
